import { render, staticRenderFns } from "./MentionsView.vue?vue&type=template&id=3fb01c99"
import script from "./MentionsView.vue?vue&type=script&lang=js"
export * from "./MentionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports